import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
  Autocomplete,
} from "@react-google-maps/api";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const googleMapKey = process.env.REACT_APP_GOOGLE_MAP_KEY;

// Google Maps libraries - must be a constant to prevent unnecessary reloads
const libraries = ["places"];

// ISO2 to ISO3 country code mapping
const iso2ToIso3 = {
  "AD": "AND", "AE": "ARE", "AF": "AFG", "AG": "ATG", "AI": "AIA",
  "AL": "ALB", "AM": "ARM", "AO": "AGO", "AQ": "ATA", "AR": "ARG",
  "AS": "ASM", "AT": "AUT", "AU": "AUS", "AW": "ABW", "AX": "ALA",
  "AZ": "AZE", "BA": "BIH", "BB": "BRB", "BD": "BGD", "BE": "BEL",
  "BF": "BFA", "BG": "BGR", "BH": "BHR", "BI": "BDI", "BJ": "BEN",
  "BL": "BLM", "BM": "BMU", "BN": "BRN", "BO": "BOL", "BQ": "BES",
  "BR": "BRA", "BS": "BHS", "BT": "BTN", "BV": "BVT", "BW": "BWA",
  "BY": "BLR", "BZ": "BLZ", "CA": "CAN", "CC": "CCK", "CD": "COD",
  "CF": "CAF", "CG": "COG", "CH": "CHE", "CI": "CIV", "CK": "COK",
  "CL": "CHL", "CM": "CMR", "CN": "CHN", "CO": "COL", "CR": "CRI",
  "CU": "CUB", "CV": "CPV", "CW": "CUW", "CX": "CXR", "CY": "CYP",
  "CZ": "CZE", "DE": "DEU", "DJ": "DJI", "DK": "DNK", "DM": "DMA",
  "DO": "DOM", "DZ": "DZA", "EC": "ECU", "EE": "EST", "EG": "EGY",
  "EH": "ESH", "ER": "ERI", "ES": "ESP", "ET": "ETH", "FI": "FIN",
  "FJ": "FJI", "FK": "FLK", "FM": "FSM", "FO": "FRO", "FR": "FRA",
  "GA": "GAB", "GB": "GBR", "GD": "GRD", "GE": "GEO", "GF": "GUF",
  "GG": "GGY", "GH": "GHA", "GI": "GIB", "GL": "GRL", "GM": "GMB",
  "GN": "GIN", "GP": "GLP", "GQ": "GNQ", "GR": "GRC", "GS": "SGS",
  "GT": "GTM", "GU": "GUM", "GW": "GNB", "GY": "GUY", "HK": "HKG",
  "HM": "HMD", "HN": "HND", "HR": "HRV", "HT": "HTI", "HU": "HUN",
  "ID": "IDN", "IE": "IRL", "IL": "ISR", "IM": "IMN", "IN": "IND",
  "IO": "IOT", "IQ": "IRQ", "IR": "IRN", "IS": "ISL", "IT": "ITA",
  "JE": "JEY", "JM": "JAM", "JO": "JOR", "JP": "JPN", "KE": "KEN",
  "KG": "KGZ", "KH": "KHM", "KI": "KIR", "KM": "COM", "KN": "KNA",
  "KP": "PRK", "KR": "KOR", "KW": "KWT", "KY": "CYM", "KZ": "KAZ",
  "LA": "LAO", "LB": "LBN", "LC": "LCA", "LI": "LIE", "LK": "LKA",
  "LR": "LBR", "LS": "LSO", "LT": "LTU", "LU": "LUX", "LV": "LVA",
  "LY": "LBY", "MA": "MAR", "MC": "MCO", "MD": "MDA", "ME": "MNE",
  "MF": "MAF", "MG": "MDG", "MH": "MHL", "MK": "MKD", "ML": "MLI",
  "MM": "MMR", "MN": "MNG", "MO": "MAC", "MP": "MNP", "MQ": "MTQ",
  "MR": "MRT", "MS": "MSR", "MT": "MLT", "MU": "MUS", "MV": "MDV",
  "MW": "MWI", "MX": "MEX", "MY": "MYS", "MZ": "MOZ", "NA": "NAM",
  "NC": "NCL", "NE": "NER", "NF": "NFK", "NG": "NGA", "NI": "NIC",
  "NL": "NLD", "NO": "NOR", "NP": "NPL", "NR": "NRU", "NU": "NIU",
  "NZ": "NZL", "OM": "OMN", "PA": "PAN", "PE": "PER", "PF": "PYF",
  "PG": "PNG", "PH": "PHL", "PK": "PAK", "PL": "POL", "PM": "SPM",
  "PN": "PCN", "PR": "PRI", "PS": "PSE", "PT": "PRT", "PW": "PLW",
  "PY": "PRY", "QA": "QAT", "RE": "REU", "RO": "ROU", "RS": "SRB",
  "RU": "RUS", "RW": "RWA", "SA": "SAU", "SB": "SLB", "SC": "SYC",
  "SD": "SDN", "SE": "SWE", "SG": "SGP", "SH": "SHN", "SI": "SVN",
  "SJ": "SJM", "SK": "SVK", "SL": "SLE", "SM": "SMR", "SN": "SEN",
  "SO": "SOM", "SR": "SUR", "SS": "SSD", "ST": "STP", "SV": "SLV",
  "SX": "SXM", "SY": "SYR", "SZ": "SWZ", "TC": "TCA", "TD": "TCD",
  "TF": "ATF", "TG": "TGO", "TH": "THA", "TJ": "TJK", "TK": "TKL",
  "TL": "TLS", "TM": "TKM", "TN": "TUN", "TO": "TON", "TR": "TUR",
  "TT": "TTO", "TV": "TUV", "TW": "TWN", "TZ": "TZA", "UA": "UKR",
  "UG": "UGA", "UM": "UMI", "US": "USA", "UY": "URY", "UZ": "UZB",
  "VA": "VAT", "VC": "VCT", "VE": "VEN", "VG": "VGB", "VI": "VIR",
  "VN": "VNM", "VU": "VUT", "WF": "WLF", "WS": "WSM", "YE": "YEM",
  "YT": "MYT", "ZA": "ZAF", "ZM": "ZMB", "ZW": "ZWE"
};

// Helper function to get ISO3 from ISO2
const getIso3FromIso2 = (iso2) => {
  if (!iso2) return null;
  return iso2ToIso3[iso2.toUpperCase()] || null;
};

export default function SelectLocation({
  open = false,
  setOpen,
  onSelect = (data) => {},
  initialLocation = null,
  showInitialLocationMarker = false,
  showTestMarker = false,
}) {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [address, setAddress] = useState("");
  const [loadingAddress, setLoadingAddress] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [autocompleteInput, setAutocompleteInput] = useState("");
  const [geocoderResult, setGeocoderResult] = useState(null);
  const [placeData, setPlaceData] = useState(null);
//   console.log("googleMapKey", googleMapKey);

  const autocompleteRef = useRef(null);
  const { t } = useTranslation("dashboard");

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: googleMapKey,
    libraries: libraries,
  });


  // Fetch location on mount
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCurrentLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      async () => {
        try {
          const response = await fetch(
            "https://api.ipregistry.co?key=tmfeo32hmi80xmyn"
          );
          const data = response.json();
          if (data?.location?.latitude && data?.location?.longitude) {
            setCurrentLocation({
              lat: data.location.latitude,
              lng: data.location.longitude,
            });
          } else {
            throw new Error("IP location not available");
          }
        } catch {
          setCurrentLocation({ lat: 28.6139, lng: 77.209 });
        }
      }
    );
  }, []);

  // Set initial location when dialog opens
  useEffect(() => {
    if (open && initialLocation) {
      console.log('Setting initial location from props:', initialLocation);
      setSelectedLocation({
        lat: initialLocation.lat,
        lng: initialLocation.lng,
      });
      setAddress(initialLocation.physicalAddress || '');
      setAutocompleteInput(initialLocation.physicalAddress || '');
    }
  }, [open, initialLocation]);

  // Handle user clicking on map
  const handleMapClick = (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    setSelectedLocation({ lat, lng });
    setLoadingAddress(true);

    const geocoder = new window.google.maps.Geocoder();
    
    // First geocoding request for full address details
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        setAddress(results[0].formatted_address);
        setAutocompleteInput(results[0].formatted_address);
        setGeocoderResult(results[0]);
        
        // Extract country code and other address components
        const addressComponents = results[0].address_components || [];
        const countryComponent = addressComponents.find(
          (component) => component.types.includes("country")
        );
        let iso2 = countryComponent?.short_name || null;
        let iso3 = getIso3FromIso2(iso2);
        let countryName = countryComponent?.long_name || null;
        
        // If country info is missing, make a second request specifically for country
        if (!iso2) {
          console.log("Country info not found in initial geocoding, requesting country-specific data...");
          geocoder.geocode(
            {
              location: { lat, lng },
              result_type: ["country"],
            },
            (countryResults, countryStatus) => {
              if (countryStatus === "OK" && countryResults[0]) {
                const countryComponents = countryResults[0].address_components || [];
                const foundCountryComponent = countryComponents.find(
                  (component) => component.types.includes("country")
                );
                if (foundCountryComponent) {
                  iso2 = foundCountryComponent.short_name || null;
                  iso3 = getIso3FromIso2(iso2);
                  countryName = foundCountryComponent.long_name || null;
                  
                  // Merge country info into the main result
                  const updatedResult = {
                    ...results[0],
                    address_components: [
                      ...addressComponents,
                      ...countryComponents.filter(
                        (comp) => !addressComponents.some((ac) => 
                          ac.types.some((type) => comp.types.includes(type))
                        )
                      ),
                    ],
                  };
                  setGeocoderResult(updatedResult);
                  
                  console.log("=== COUNTRY-SPECIFIC GEOCODER RESULT ===");
                  console.log("Country Result:", countryResults[0]);
                  console.log("Updated ISO2:", iso2);
                  console.log("Updated ISO3:", iso3);
                  console.log("Updated Country Name:", countryName);
                  
                  // Log the final result with updated data
                  console.log("=== MAP CLICK - FINAL GEOCODER RESULT ===");
                  console.log("Full geocoder result:", updatedResult);
                  console.log("All address components:", updatedResult.address_components);
                  console.log("ISO2 (ISO 3166-1 alpha-2):", iso2);
                  console.log("ISO3 (ISO 3166-1 alpha-3):", iso3);
                  console.log("Country Name:", countryName);
                  console.log("Formatted Address:", results[0].formatted_address);
                  console.log("Geometry:", results[0].geometry);
                  console.log("Place ID:", results[0].place_id);
                  console.log("Types:", results[0].types);
                  
                  // Log all address component types for reference
                  updatedResult.address_components.forEach((component) => {
                    console.log(`  - ${component.types.join(", ")}: ${component.long_name} (${component.short_name})`);
                  });
                } else {
                  // Country not found even in country-specific request
                  console.log("=== MAP CLICK - FINAL GEOCODER RESULT (NO COUNTRY) ===");
                  console.log("Full geocoder result:", results[0]);
                  console.log("All address components:", addressComponents);
                  console.log("ISO2 (ISO 3166-1 alpha-2):", null);
                  console.log("ISO3 (ISO 3166-1 alpha-3):", null);
                  console.log("Country Name:", null);
                  console.log("Formatted Address:", results[0].formatted_address);
                  console.log("Note: Country information not available for this location");
                }
              } else {
                // Country geocoding request failed
                console.log("=== MAP CLICK - FINAL GEOCODER RESULT (COUNTRY REQUEST FAILED) ===");
                console.log("Full geocoder result:", results[0]);
                console.log("All address components:", addressComponents);
                console.log("ISO2 (ISO 3166-1 alpha-2):", null);
                console.log("ISO3 (ISO 3166-1 alpha-3):", null);
                console.log("Country Name:", null);
                console.log("Country geocoding status:", countryStatus);
              }
              
              setLoadingAddress(false);
            }
          );
        } else {
          // Country info found in initial request
          console.log("=== MAP CLICK - GEOCODER RESULT ===");
          console.log("Full geocoder result:", results[0]);
          console.log("All address components:", addressComponents);
          console.log("ISO2 (ISO 3166-1 alpha-2):", iso2);
          console.log("ISO3 (ISO 3166-1 alpha-3):", iso3);
          console.log("Country Name:", countryName);
          console.log("Formatted Address:", results[0].formatted_address);
          console.log("Geometry:", results[0].geometry);
          console.log("Place ID:", results[0].place_id);
          console.log("Types:", results[0].types);
          
          // Log all address component types for reference
          addressComponents.forEach((component) => {
            console.log(`  - ${component.types.join(", ")}: ${component.long_name} (${component.short_name})`);
          });
          
          setLoadingAddress(false);
        }
      } else {
        setAddress(t("addressNotFound"));
        setGeocoderResult(null);
        console.log("Geocoder error:", status);
        setLoadingAddress(false);
      }
    });
  };

  // Handle location selected from autocomplete
  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setSelectedLocation({ lat, lng });
        setAddress(place.formatted_address);
        setAutocompleteInput(place.formatted_address);
        setPlaceData(place);
        
        // Extract country code and other address components
        const addressComponents = place.address_components || [];
        const countryComponent = addressComponents.find(
          (component) => component.types.includes("country")
        );
        let iso2 = countryComponent?.short_name || null;
        let iso3 = getIso3FromIso2(iso2);
        let countryName = countryComponent?.long_name || null;
        
        // If country info is missing, make a geocoding request specifically for country
        if (!iso2 && place.geometry?.location) {
          console.log("Country info not found in autocomplete place, requesting country-specific data...");
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode(
            {
              location: {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng(),
              },
              result_type: ["country"],
            },
            (countryResults, countryStatus) => {
              if (countryStatus === "OK" && countryResults[0]) {
                const countryComponents = countryResults[0].address_components || [];
                const foundCountryComponent = countryComponents.find(
                  (component) => component.types.includes("country")
                );
                if (foundCountryComponent) {
                  iso2 = foundCountryComponent.short_name || null;
                  iso3 = getIso3FromIso2(iso2);
                  countryName = foundCountryComponent.long_name || null;
                  
                  // Merge country info into place data
                  const updatedPlace = {
                    ...place,
                    address_components: [
                      ...addressComponents,
                      ...countryComponents.filter(
                        (comp) => !addressComponents.some((ac) => 
                          ac.types.some((type) => comp.types.includes(type))
                        )
                      ),
                    ],
                  };
                  setPlaceData(updatedPlace);
                  
                  console.log("=== COUNTRY-SPECIFIC GEOCODER RESULT (AUTOCOMPLETE) ===");
                  console.log("Country Result:", countryResults[0]);
                  console.log("Updated ISO2:", iso2);
                  console.log("Updated ISO3:", iso3);
                  console.log("Updated Country Name:", countryName);
                }
              }
            }
          );
        }
        
        console.log("=== AUTCOMPLETE - PLACE DATA ===");
        console.log("Full place object:", place);
        console.log("All address components:", addressComponents);
        console.log("ISO2 (ISO 3166-1 alpha-2):", iso2);
        console.log("ISO3 (ISO 3166-1 alpha-3):", iso3);
        console.log("Country Name:", countryName);
        console.log("Formatted Address:", place.formatted_address);
        console.log("Geometry:", place.geometry);
        console.log("Place ID:", place.place_id);
        console.log("Types:", place.types);
        console.log("Name:", place.name);
        console.log("Vicinity:", place.vicinity);
        
        // Log all address component types for reference
        addressComponents.forEach((component) => {
          console.log(`  - ${component.types.join(", ")}: ${component.long_name} (${component.short_name})`);
        });
      }
    }
  };

  const handleSubmit = () => {
    if (selectedLocation) {
      // Extract country code from stored geocoder result or place data
      const addressComponents = geocoderResult?.address_components || placeData?.address_components || [];
      const countryComponent = addressComponents.find(
        (component) => component.types.includes("country")
      );
      const iso2 = countryComponent?.short_name || null;
      const iso3 = getIso3FromIso2(iso2);
      const countryName = countryComponent?.long_name || null;
      
      // Extract other useful components
      const postalCodeComponent = addressComponents.find(
        (component) => component.types.includes("postal_code")
      );
      const postalCode = postalCodeComponent?.long_name || null;
      
      const administrativeAreaComponent = addressComponents.find(
        (component) => component.types.includes("administrative_area_level_1")
      );
      const state = administrativeAreaComponent?.long_name || null;
      const stateCode = administrativeAreaComponent?.short_name || null;
      
      const localityComponent = addressComponents.find(
        (component) => component.types.includes("locality")
      );
      const city = localityComponent?.long_name || null;
      
      console.log("=== SUBMITTING LOCATION DATA ===");
      console.log("Lat:", selectedLocation.lat);
      console.log("Lng:", selectedLocation.lng);
      console.log("Address:", address);
      console.log("ISO2 (ISO 3166-1 alpha-2):", iso2);
      console.log("ISO3 (ISO 3166-1 alpha-3):", iso3);
      console.log("Country Name:", countryName);
      console.log("Postal Code:", postalCode);
      console.log("State:", state);
      console.log("State Code:", stateCode);
      console.log("City:", city);
      console.log("Full geocoder result:", geocoderResult);
      console.log("Full place data:", placeData);
      
      let object = {
        longitude: selectedLocation.lng,
        latitude: selectedLocation.lat,
        physicalAddress: address,
        iso2: iso2,
        iso3: iso3,
        countryCode: iso2, // Keep for backward compatibility
        countryName: countryName,
        postalCode: postalCode,
        state: state,
        stateCode: stateCode,
        city: city,
        // Include full address components for reference
        addressComponents: addressComponents,
      };
      
      console.log("Final object being sent to onSelect:", object);
      onSelect(object);
      setOpen(false);
    }
  };

   useEffect(() => {
    const css = `.pac-container { z-index: 2000 !important; }`;
    const style = document.createElement("style");
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, [open]);

  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{t("selectLocationOnMap")}</DialogTitle>
        <DialogContent>
          {loadError ? (
            <p>{t("errorLoadingMaps")}</p>
          ) : !isLoaded || !currentLocation ? (
            <p>{t("loadingMap")}</p>
          ) : (
            <>
              {/* Autocomplete Search Field */}
              <Autocomplete
                onLoad={(ref) => (autocompleteRef.current = ref)}
                onPlaceChanged={onPlaceChanged}
              >
                <TextField
                  fullWidth
                  label={t("searchLocation")}
                  variant="outlined"
                  value={autocompleteInput}
                  onChange={(e) => setAutocompleteInput(e.target.value)}
                  sx={{ my: 2 }}
                />
              </Autocomplete>

              {/* Map */}
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={selectedLocation || currentLocation}
                zoom={14}
                onClick={handleMapClick}
              >
                
                {/* Always show a test marker at center to verify markers work */}
                {showTestMarker && (
                  <Marker 
                    position={currentLocation}
                    title="Test marker - should always show"
                  />
                )}
                
                {/* Show current/selected location marker */}
                {(selectedLocation || currentLocation) && (
                  <Marker 
                    position={selectedLocation || currentLocation}
                    title="Current location"
                  />
                )}
                
                {/* Show initial location marker if different from current selection */}
                {showInitialLocationMarker && initialLocation && selectedLocation && 
                 (initialLocation.lat !== selectedLocation.lat || initialLocation.lng !== selectedLocation.lng) && (
                  <Marker 
                    position={initialLocation}
                    title="Previously selected location"
                    icon={{
                      path: window.google.maps.SymbolPath.CIRCLE,
                      scale: 8,
                      fillColor: "#ff9800",
                      fillOpacity: 1,
                      strokeColor: "#ffffff",
                      strokeWeight: 2,
                    }}
                  />
                )}
              </GoogleMap>
            </>
          )}
          <div style={{ marginTop: 12 }}>
            <strong>{t("selectedAddressLabel")}</strong>
            <br />
            {loadingAddress
              ? t("fetchingAddress")
              : address || t("clickMapToSelectLocation")}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} sx={{ color: "#FFF" }}>
            {t("common:cancel")}
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={!selectedLocation}
          >
            {t("confirmLocation")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
